import {StoreModel} from '@/store/models/StoreModel'
import { orderBy } from 'lodash';
import { ProductStoreChannelModel } from './ProductStoreChannelModel';

export class ProductStoreModel {
    id?: string = undefined;
    idProduct?: string = undefined;
    idStore?: string = undefined;
    stockQty: number|null = null;
    reservedStockQty: number|null = null;
    isActive: boolean = true;
    store: StoreModel|undefined = undefined;
    costPrice:number = 0;
    listPrice:number = 0;
    sellPrice:number = 0;
    channels: ProductStoreChannelModel[] = [];
    blockStock: boolean = false;

    constructor(p?:Partial<ProductStoreModel>) {
        Object.assign(this, p)

        this._parseStoreModel()
        this._parseStoreChannels()
    }

    hasChannels():boolean {
        return !!this.channels.length
    }

    totalAvailableStockQty():number {
        return (this.stockQty || 0) - (this.reservedStockQty || 0);
    }

    private _parseStoreModel():void {
        this.store = new StoreModel(this.store)
    }

    private _parseStoreChannels():void {
        this.channels = orderBy(this.channels.map((channel) => {
            return new ProductStoreChannelModel(channel);
        }), ['channel.name'], ['asc']);
    }
}

